<template>
  <div>
    <app-collapse-item
      v-for="item in list"
      :key="item.id"
    >
      <template #header>
        <span class=""><strong class="text-primary">{{
          $moment(item.datetime)
            .format('LT')
        }}</strong> &nbsp; {{ item.crop.name }} ({{
          item.crop_type.name
        }})</span>
      </template>

      <table>
        <tr>
          <td class="pb-1">
            <strong>{{ $t('therms.external_id') }} :</strong>
          </td>
          <td class="pb-1">
            {{ item.external_id }}
          </td>
        </tr>
        <tr v-if="hasMultipleFarmers">
          <td>
            <strong>{{ $t('therms.farmer') }} :</strong>
          </td>
          <td>
            {{ item.farmer.name }}
          </td>
        </tr>
        <tr v-if="item.account !== null">
          <td class="pb-1">
            <strong>{{ $t('therms.account') }} :</strong>
          </td>
          <td class="pb-1">
            {{ item.account.name }}
          </td>
        </tr>
        <tr>
          <td><strong>{{ $t('therms.crop_family') }} :</strong></td>
          <td>
            {{ $t('therms.crop_family_' + item.crop_family.slug) }}
          </td>
        </tr>
        <tr>
          <td><strong>{{ $t('therms.crop') }} :</strong></td>
          <td>
            {{ item.crop.emoji }}
            {{ item.crop.name }}
          </td>
        </tr>
        <tr>
          <td><strong>{{ $t('therms.crop-type') }} :</strong></td>
          <td>
            {{ item.crop_type.name }}
          </td>
        </tr>
        <tr>
          <td><strong>{{ $t('therms.plot') }} :</strong></td>
          <td>
            {{
              (item.plot.name !== item.plot.abbreviation ? item.plot.name + '(' + item.plot.abbreviation + ')' :
                item.plot.name)
            }}
          </td>
        </tr>
        <tr v-if="item.crop_grade !== null">
          <td><strong>{{ $t('therms.crop-grade') }} :</strong></td>
          <td> {{ item.crop_grade.name }}</td>
        </tr>
        <tr v-if="item.crop_packing !== null">
          <td><strong>{{ $t('therms.crop-packing') }} :</strong></td>
          <td> {{ item.crop_packing.name }}</td>
        </tr>
        <tr>
          <td><strong>{{ $t('therms.quantity') }} :</strong></td>
          <td> {{ item.quantity }}</td>
        </tr>
        <tr v-if="item.carrier">
          <td class="pt-1">
            <strong>{{ $t('therms.carrier') }} :</strong>
          </td>
          <td class="pt-1">
            {{ item.carrier.name }}
          </td>
        </tr>
        <tr>
          <td class="pt-1">
            <strong>{{ $t('therms.status') }} :</strong>
          </td>
          <td class="pt-1">
            <b-badge :variant="status[1][item.is_valid ? 1 : 0]">
              {{ status[0][item.is_valid ? 1 : 0] }}
            </b-badge>
          </td>
        </tr>
      </table>
      <div class="d-flex mt-2 mb-1">
        <touch-button
          size="sm"
          class="mr-50"
          @action="openUrl(item.pdf_url)"
        >
          <i class="fa-solid fa-file-invoice" />
          <span class="ml-1">
            {{ $t('therms.see-pallet-sheet') }}
          </span>
        </touch-button>
      </div>
      <div class="d-flex">
        <touch-icon-button
          size="md"
          color="secondary"
          class="mr-50"
          @action="openUrl"
        >
          <i class="fa-solid fa-tag" />
        </touch-icon-button>
        <touch-icon-button
          size="md"
          color="secondary"
          class="mr-50"
          @action="openUrl"
        >
          <i class="fa-solid fa-code" />
        </touch-icon-button>
      </div>

    </app-collapse-item>
  </div>
</template>
<script>
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import TouchIconButton from '@core/components/touch-button/TouchIconButton.vue'
import TouchButton from '@core/components/touch-button/TouchButton.vue'
import { BBadge } from 'bootstrap-vue'
import { Browser } from '@capacitor/browser'
import { mapGetters } from 'vuex'

export default {
  name: 'AppCollapseExpeditionSheet',
  components: {
    AppCollapseItem,
    TouchIconButton,
    TouchButton,
    BBadge,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      hasMultipleFarmers: 'farmers/hasMultipleFarmers',
    }),
    status() {
      return [
        {
          1: this.$t('therms.shipped'),
          0: this.$t('therms.canceled'),
        },
        {
          1: 'light-success',
          0: 'light-danger',
        },
      ]
    },
  },
  methods: {
    /**
     * @param {String} url
     * @returns {Promise<void>}
     */
    async openUrl(url) {
      await Browser.open({ url })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@core/scss/base/bootstrap-extended/_include';
@import '@core/scss/base/components/_include';

table tr td:nth-child(2) {
  padding-left: 20px;
}

</style>
